<template>
    <div class="position-relative">
        <v-app class="p-4">
            <BankCards></BankCards>
        </v-app>
    </div>
</template>

<script>
import ErfCard from "../erfan";
import BankCards from "./BankCards";
import TitleRibbon from "../uiBeautifier/titleRibbon";
import CitySelector from "../mainComponents/citySelector";
import ProvinceSelector from "../mainComponents/provinceSelector";

export default {
    name: "Banks",
    components: {
        TitleRibbon, BankCards, ErfCard, CitySelector,
        ProvinceSelector
    },
}
</script>

<style scoped>

</style>